export const LOAD_POSTS_REQUEST = 'LOAD_POSTS_REQUEST'
export const LOAD_POSTS_FAILURE = 'LOAD_POSTS_FAILURE'
export const LOAD_POSTS_SUCCESS = 'LOAD_POSTS_SUCCESS'

export const LOAD_POST_REQUEST = 'LOAD_POST_REQUEST'
export const LOAD_POST_FAILURE = 'LOAD_POST_FAILURE'
export const LOAD_POST_SUCCESS = 'LOAD_POST_SUCCESS'

export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST'
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE'
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS'

export const LOAD_MY_REQUEST = 'LOAD_MY_REQUEST'
export const LOAD_MY_FAILURE = 'LOAD_MY_FAILURE'
export const LOAD_MY_SUCCESS = 'LOAD_MY_SUCCESS'

export const TOGGLE_POST_FORM = 'TOGGLE_POST_FORM'
export const TOGGLE_COMMENT_FORM = 'TOGGLE_COMMENT_FORM'

export const CREATE_POST_REQUEST = 'CREATE_POSTS_REQUEST'
export const CREATE_POST_FAILURE = 'CREATE_POSTS_FAILURE'
export const CREATE_POST_SUCCESS = 'CREATE_POSTS_SUCCESS'

export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST'
export const CREATE_COMMENT_FAILURE = 'CREATE_COMMENT_FAILURE'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'

export const UPDATE_POST_INPUT = 'UPDATE_POST_INPUT'
export const UPDATE_COMMENT_INPUT = 'UPDATE_COMMENT_INPUT'

export const LOAD_USER_POSTS_REQUEST = 'LOAD_USER_POSTS_REQUEST'
export const LOAD_USER_POSTS_FAILURE = 'LOAD_USER_POSTS_FAILURE'
export const LOAD_USER_POSTS_SUCCESS = 'LOAD_USER_POSTS_SUCCESS'

export const LOAD_MY_LIKES_REQUEST = 'LOAD_MY_LIKES_REQUEST'
export const LOAD_MY_LIKES_FAILURE = 'LOAD_MY_LIKES_FAILURE'
export const LOAD_MY_LIKES_SUCCESS = 'LOAD_MY_LIKES_SUCCESS'

export const LOAD_MY_COMMENTS_REQUEST = 'LOAD_MY_COMMENTS_REQUEST'
export const LOAD_MY_COMMENTS_FAILURE = 'LOAD_MY_COMMENTS_FAILURE'
export const LOAD_MY_COMMENTS_SUCCESS = 'LOAD_MY_COMMENTS_SUCCESS'

export const DELETE_POST_REQUEST = 'DELETE_POST_REQUEST'
export const DELETE_POST_FAILURE = 'DELETE_POST_FAILURE'
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS'

export const ACTIVE_POST = 'ACTIVE_POST'
export const TOGGLE_INTRO = 'TOGGLE_INTRO'

export const CREATE_COMMENT_LIKE_REQUEST = 'CREATE_COMMENT_LIKE_REQUEST'
export const CREATE_COMMENT_LIKE_FAILURE = 'CREATE_COMMENT_LIKE_FAILURE'
export const CREATE_COMMENT_LIKE_SUCCESS = 'CREATE_COMMENT_LIKE_SUCCESS'

export const CREATE_POST_LIKE_REQUEST = 'CREATE_POST_LIKE_REQUEST'
export const CREATE_POST_LIKE_FAILURE = 'CREATE_POST_LIKE_FAILURE'
export const CREATE_POST_LIKE_SUCCESS = 'CREATE_POST_LIKE_SUCCESS'


export const LOAD_WXCONFIG_REQUEST = 'LOAD_WXCONFIG_REQUEST'
export const LOAD_WXCONFIG_FAILURE = 'LOAD_WXCONFIG_FAILURE'
export const LOAD_WXCONFIG_SUCCESS = 'LOAD_WXCONFIG_SUCCESS'



// WEBPACK FOOTER //
// ./src/constants.js